<shell>
    <router-outlet></router-outlet>
</shell>